module.exports = __webpack_public_path__ + "img/bg_ruins.f7dc78d5.jpg";